export default __webpack_public_path__ + "static/media/DtVkJx26TKEr37c9aBBxOloc5ijTjQJElti5.b0f8a736.woff2";